import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import projects from './modules/projects'
import invoices from './modules/invoices'
import items from './modules/items'
import testLinks from './modules/test_links'

import {
  fetchUser
} from '../api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null
  },
  mutations: {

    setUser (state, user) {
      state.user = user
    }

  },
  actions: {

    getUser ({ commit, state }) {
      return state.user
        ? Promise.resolve(state.user)
        : fetchUser().then(user => commit('setUser', user))
    }

  },
  getters: {

    getPrimaryAccount ({ state }) {
      return state.user.accounts[0]
    }

  },
  modules: {
    auth,
    projects,
    invoices,
    items,
    testLinks
  }
})
